@if (isResolving()) {
  <app-platform-loader />
}
<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <router-outlet />
</div>
